import Parameters from './DashboardParameters';
export default Parameters;